

export class ExpenseTypeAddOutput implements IExpenseTypeAddOutput {
    status!: number;
    message!: string;

    constructor(data?: IExpenseTypeAddOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ExpenseTypeAddOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTypeAddOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data; 
    }
}

export interface IExpenseTypeAddOutput {
    status: number;
    message: string;
}

